export default __webpack_public_path__ + "static/media/Union2.e20ebbe5.png";